import { render, staticRenderFns } from "./InstallationGuide.vue?vue&type=template&id=90af27b4&"
import script from "./InstallationGuide.vue?vue&type=script&lang=ts&"
export * from "./InstallationGuide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports